"use client";

import { sizes } from "@/components/bloks/Asset";
import { Carousel } from "@/components/ui/Carousel";
import { ProductCardWithCampaigns } from "@/features/campaigns";
import { useTranslations } from "@/i18n/client";
import { useRecommendationClick } from "@/lib/depict/useRecommendationClick";
import { useToken } from "@frend-digital/centra/client";
import { useQuery } from "@tanstack/react-query";
import { rpc } from "#rpc";

import styles from "./RecentlyViewed.module.css";

export const RecentlyViewed = ({
	productIds,
}: {
	productIds: (string | undefined)[];
}) => {
	const t = useTranslations();
	const token = useToken();
	const { data: products } = useQuery({
		queryKey: ["depict-recommendations-recently-viewed", productIds],
		queryFn: async () => {
			const products = await rpc.depict.recommendations({
				product_ids: productIds,
				type: "recently_viewed",
				limit: 8,
				token: token!,
			});

			return products;
		},
		enabled: !!token,
	});

	const handleProductClick = useRecommendationClick(products, "recently_viewed");

	if (!products || products.length === 0) return null;

	return (
		// biome-ignore lint/a11y/useKeyWithClickEvents: keyboard navigation handled by individual product cards
		<div className={styles.root} onClick={handleProductClick}>
			<Carousel
				activeScroll={products.length > 4}
				title={t("Recently viewed")}
				showControls={products.length > 4}
			>
				{products.map((filteredProduct) => (
					<ProductCardWithCampaigns
						sizes={sizes(75, 25)}
						product={filteredProduct}
						key={filteredProduct.displayItemId}
						showRatings
					/>
				))}
			</Carousel>
		</div>
	);
};
